
export default function FetchContent(res){
    
    return new Promise(function(resolve){
      
      const cssPromise = new Promise((resolve)=>{
        import(/*webpackPreload: true */ /* webpackChunkName: "[request]" */ `../assets/stylesheets/modules/${res}.scss`).then(() => {
          console.log("Loaded CSS");
          resolve(true)
        },(err)=>{
          console.log("Error", err)
        })
        
      })
      const jsPromise = new Promise((resolve)=>{
        import(/*webpackPreload: true */ /* webpackChunkName: "[request]" */ `./controllers/${res}`).then(() => {
          console.log("Loaded JS");
          resolve(true)
        },(err)=>{
          console.log("Error", err)
        })
    
      })
      Promise.all([cssPromise,jsPromise]).then(()=>{
        resolve(true);
      })

    })

}
